module.exports = __webpack_public_path__ + "static/media/Treasure.e91c338f.png";